import Vue from 'vue'
import Router from 'vue-router'

// Pages
import AboutUs from '@/pages/PageAboutUs'
import Blog from '@/pages/PageBlog'
import BlogPost from '@/pages/PageBlogPost'
import Contact from '@/pages/PageContact'
import Home from '@/pages/PageHome'
import NotFound from '@/pages/PageNotFound'
import OurTeam from '@/pages/PageOurTeam'
import Portfolio from '@/pages/PagePortfolio'
import Project from '@/pages/PageProject'
import RequestQuote from '@/pages/PageRequestQuote'
import Services from '@/pages/PageServices'
import ServiceDetail from '@/pages/PageServiceDetail'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
    },
    {
      path: '/about-us',
      name: 'AboutUs',
      component: AboutUs,
    },
    {
      path: '/our-team',
      name: 'OurTeam',
      component: OurTeam,
    },
    {
      path: '/services',
      name: 'Services',
      component: Services,
    },
    {
      path: '/services/:slug',
      name: 'ServiceDetail',
      component: ServiceDetail,
      props: true,
    },
    {
      path: '/portfolio',
      name: 'Portfolio',
      component: Portfolio,
    },
    {
      path: '/portfolio/:slug',
      name: 'Project',
      component: Project,
      props: true,
    },
    {
      path: '/blog',
      name: 'Blog',
      component: Blog,
    },
    {
      path: '/blog-posts/:slug',
      name: 'BlogPost',
      component: BlogPost,
      props: true,
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact,
    },
    {
      path: '/request-quote',
      name: 'RequestQuote',
      component: RequestQuote,
    },
    { path: '*', component: NotFound },
  ],
})

// function initiateWebflow() {
//   setTimeout(() => {
//     // eslint-disable-next-line
//     $(Webflow.ready);
//   }, 1);
// }

// function reInitiateWebflow() {
// eslint-disable-next-line
// $(Webflow.destroy);
// }

// router.beforeEach((to, from, next) => {
//   Console.log(to, from, next);
//   // reInitiateWebflow();
//   initiateWebflow();
// });

export default router
